import { render, staticRenderFns } from "./CommentSummary.vue?vue&type=template&id=5ce8ed76&scoped=true&"
import script from "./CommentSummary.vue?vue&type=script&lang=js&"
export * from "./CommentSummary.vue?vue&type=script&lang=js&"
import style0 from "./CommentSummary.vue?vue&type=style&index=0&id=5ce8ed76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce8ed76",
  null
  
)

export default component.exports